import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';
import { useAuth } from './useAuth.js';

const AuthContext = createContext({});
// add error handling later
const AuthProvider = ({ children }) => {
    return jsx(AuthContext.Provider, { value: useAuth(), children: children });
};

export { AuthProvider };
